import React, { useEffect, useState } from "react";
import isPropValid from "@emotion/is-prop-valid";
import { StyleSheetManager, WebTarget } from "styled-components";
import { ThemeComponent } from "./components/theme-component";
import { isSFLVeryIEHeaderEnabled as checkSFLHeaderClientSide } from "./utils/helpers";
import Autosuggest from "./views/autosuggest";

const shouldForwardProp = (propName: string, target: WebTarget | undefined) => {
  if (typeof target === "string") {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName);
  }
  // For other elements, forward all props
  return true;
};

const App: React.FC<{
  brand?: "default" | "littlewoods" | "very" | "veryireland";
}> = ({ brand = "very" }) => {
  const [isSFLHeaderClientSide, setIsSFLHeaderClientSide] = useState<
    boolean | undefined
  >(undefined);
  useEffect(() => {
    if (typeof window !== "undefined" && typeof navigator !== "undefined") {
      const userAgent = navigator.userAgent;
      setIsSFLHeaderClientSide(checkSFLHeaderClientSide(userAgent));
    }
  }, []);

  return (
    <StyleSheetManager
      enableVendorPrefixes
      shouldForwardProp={shouldForwardProp}
    >
      <ThemeComponent brand={brand} />
      <Autosuggest
        brand={brand}
        isSFLVeryIEHeaderEnabled={isSFLHeaderClientSide ?? false}
      />
    </StyleSheetManager>
  );
};

export default App;
